declare global {
  interface Window {
    __GRIDLINE_CONFIG__?: {
      apiUrl?: string;
      googleMapsApiKey?: string;
      googleMapsMapId?: string;
      mapboxAccessToken?: string;
      googleOAuthClientId?: string;
      appleSignInClientId?: string;
      appleSignInRedirectUri?: string;
      sentryDsn?: string;
      sentryEnvironment?: string;
    };
  }
}

export function getRuntimeApiUrl(): string | undefined {
  return typeof window === 'undefined' ? undefined : window.__GRIDLINE_CONFIG__?.apiUrl;
}

export function getSentryDsn(): string | null {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.sentryDsn?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_SENTRY_DSN?.trim();
  return fromVite || null;
}

export function getSentryEnvironment(): string {
  return window.__GRIDLINE_CONFIG__?.sentryEnvironment?.trim() || import.meta.env.MODE;
}

export function getGoogleMapsApiKey(): string | null {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.googleMapsApiKey?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_GOOGLE_MAPS_API_KEY?.trim();
  return fromVite || null;
}

export function getGoogleMapsMapId(): string | null {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.googleMapsMapId?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID?.trim();
  return fromVite || null;
}

export function getMapboxAccessToken(): string | null {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.mapboxAccessToken?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN?.trim();
  return fromVite || null;
}

export function mapboxMissingKeyHint() {
  return 'Add VITE_MAPBOX_ACCESS_TOKEN to apps/web/.env (see apps/web/.env.example), then restart the dev server.';
}

/** Places Autocomplete is on by default in Vite dev; override with VITE_GOOGLE_PLACES_AUTOCOMPLETE. */
export function isGooglePlacesAutocompleteEnabled(): boolean {
  const flag = import.meta.env.VITE_GOOGLE_PLACES_AUTOCOMPLETE?.trim().toLowerCase();
  if (flag === 'true' || flag === '1') {
    return true;
  }
  if (flag === 'false' || flag === '0') {
    return false;
  }

  return import.meta.env.DEV;
}

export function getGoogleOAuthClientId(): string | null {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.googleOAuthClientId?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID?.trim();
  return fromVite || null;
}

export function getAppleSignInClientId(): string | null {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.appleSignInClientId?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_APPLE_SIGN_IN_CLIENT_ID?.trim();
  return fromVite || null;
}

export function getAppleSignInRedirectUri(): string {
  const fromRuntime = window.__GRIDLINE_CONFIG__?.appleSignInRedirectUri?.trim();
  if (fromRuntime) {
    return fromRuntime;
  }

  const fromVite = import.meta.env.VITE_APPLE_SIGN_IN_REDIRECT_URI?.trim();
  if (fromVite) {
    return fromVite;
  }

  return `${window.location.origin}/login`;
}
